import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const stats = [
  { value: 100, suffix: "%", label: "Focused on keeping families together" },
  { value: 3, suffix: "+", label: "Coordinated support programs" },
  { value: 24, suffix: "/7", label: "Community-based care mindset" },
  { value: 1, suffix: " goal", label: "Housing stability & independence" },
];

const Counter = ({ value, suffix, active }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = null;
    const duration = 1600;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) requestAnimationFrame(step);
    };
    const raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [active, value]);
  return (
    <span>
      {n}
      {suffix}
    </span>
  );
};

const Impact = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="impact"
      ref={ref}
      data-testid="impact-section"
      className="relative bg-[#C85A3C] text-[#F4F1EA] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-xs uppercase tracking-[0.3em] text-[#F4F1EA]/70 mb-14"
        >
          Our Commitment
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.7 }}
              data-testid={`stat-${i}`}
            >
              <div className="font-serif-display text-6xl md:text-7xl font-light leading-none tracking-tight">
                <Counter value={s.value} suffix={s.suffix} active={inView} />
              </div>
              <div className="h-px w-12 bg-[#F4F1EA]/40 my-5" />
              <p className="text-sm md:text-base text-[#F4F1EA]/80 leading-snug max-w-[220px]">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
